import React from "react";
import { motion } from "framer-motion";

const partners = [
  { name: "Antam", logo: "/antam.png" },
  {
    name: "Pertamina",
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Pertamina_Logo.svg",
  },
  { name: "Baker Hughes", logo: "/bkr.svg" },
  { name: "Asta Bumi Cipta", logo: "/asta.png" },
  { name: "Chemstar Indonesia", logo: "/chemstar.jpeg" },
  {
    name: "WIKA",
    logo: "https://upload.wikimedia.org/wikipedia/commons/e/eb/WIKA_Logo.svg",
  },
  { name: "DLH Karawang", logo: "/dlh.jpg" },
  {
    name: "Bayer Indonesia",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Logo_Bayer.svg",
  },
];

// Animasi container untuk efek berurutan
const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

// Animasi masing-masing logo
const itemVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
};

const PartnerLogos = () => {
  return (
    <motion.div
      className="partner-section mb-10 text-center"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      <h1 className="text-4xl font-bold mb-10 drop-shadow-lg text-center">
        Our Partners
      </h1>
      <div className="partner-logos grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-6xl mx-auto mt-5">
        {partners.map((partner) => (
          <motion.div
            key={partner.name}
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300 flex items-center justify-center"
          >
            <img
              src={partner.logo}
              alt={partner.name}
              className="h-28 object-contain transition duration-300"
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default PartnerLogos;
